module.exports = __webpack_public_path__ + "img/detail3.05108923.png";